module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/btn_consult-10e9865c7acd2fedac5d214d913457cc.png";